// extracted by mini-css-extract-plugin
module.exports = {"emoji_wrapper":"EmojiPicker_emoji_wrapper__32itd"};